'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.ui-components.fold-out.cbFoldOutController', []);

_module.component('cbFoldOut', {
    template: "<div class=\"cb-fold-out\" data-ng-class=\"{'cb-fold-out--open' : vm.contentVisible, 'cb-fold-out--pristine': !vm.contentVisible, 'cb-fold-out--is-animating' : vm.isAnimating}\" data-ng-style=\"{ 'padding' : vm.padding ? vm.padding : '0' }\">\r\n\r\n    <section class=\"cb-fold-out__header\" data-ng-class=\"vm.contentVisible ? 'cb-fold-out__header--open' : 'cb-fold-out__header--pristine'\"  data-ng-click=\"vm.toggleDetails()\">\r\n        <h2 class=\"cb-fold-out__title\">{{vm.title}}</h2>\r\n        <a href=\"javascript:\" data-ng-class=\"vm.contentVisible ? 'cb-fold-out__link-active' : ''\" class=\"cb-fold-out__link\">\r\n            <span data-ng-if=\"!vm.contentVisible\">{{vm.labelUnexpanded || 'Toon details'}}</span>\r\n            <span data-ng-if=\"vm.contentVisible\">{{vm.labelExpanded || 'Toon minder'}}</span>\r\n            <span class=\"tilting-chevron\"\r\n                  data-ng-class=\"vm.contentVisible ? 'tilting-chevron--down' : 'tilting-chevron--up'\">\r\n            </span>\r\n        </a>\r\n    </section>\r\n\r\n    <section class=\"cb-fold-out__body\" data-ng-class=\"vm.contentVisible ? 'cb-fold-out__body-open' : ''\">\r\n        <div class=\"cb-fold-out__text\">\r\n            <ng-transclude>\r\n                <p>Please include content within the component tags to display on unfold.</p>\r\n            </ng-transclude>\r\n        </div>\r\n    </section>\r\n\r\n</div>\r\n",
    transclude: true,
    bindings: {
        title: '@',
        padding: '@',
        labelExpanded: '@',
        labelUnexpanded: '@'
    },
    controller: ('cbFoldOutController', cbFoldOutController),
    controllerAs: 'vm'
});

function cbFoldOutController($scope) {
    var vm = this;
    vm.contentVisible = false;
    vm.isAnimating = false;
    vm.animationDuration = 400;

    vm.foldoutIsAnimating = function () {
        vm.isAnimating = true;
        setTimeout(function () {
            vm.isAnimating = false;
            $scope.$apply();
        }, vm.animationDuration);
    };

    vm.toggleDetails = function () {
        vm.contentVisible = !vm.contentVisible;
        vm.foldoutIsAnimating();
    };
}
cbFoldOutController.$inject = ['$scope'];

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/fold-out/cb-fold-out.component.js
// module id = 886
// module chunks = 0